import { classNamesSetClass } from './utils'

export function classNamesSetTheme(classNames, theme) {
  return classNamesSetClass(classNames, 'th-', theme)
}

export function setThemeBodyClass(theme) {
  window.document.body.className = classNamesSetTheme(window.document.body.className, theme)
}
